module.exports = __webpack_public_path__ + "static/media/interior1.155fd232.svg";